import {
  DELETE_RULE_FROM_STATE,
  PARSE_RULE_DONE,
  SET_RULE_STATE,
  SET_RULES_FOR_APPLICATION_CONNECTION,
  UPDATE_ENABLED_DISABLED_STATE,
} from './constants';
import {
  DeleteRuleFromStateAction,
  ParseRuleDoneAction,
  ReceiptRulesAction,
  ReceiptRulesState,
  SetRulesForApplicationConnectionAction,
  SetRuleStateAction,
  UpdatedEnabledStateAction,
} from './types';

const initialState: ReceiptRulesState = {
  loading: false,
  rules: null,
  rulesConnectionId: null,
  parsedRule: null,
};

export const receiptRulesReducer = (
  state = initialState,
  action: ReceiptRulesAction
): ReceiptRulesState => {
  switch (action.type) {
    case SET_RULES_FOR_APPLICATION_CONNECTION:
      return handleSetRulesForApplicationConnectionRequest(state, action);
    case SET_RULE_STATE:
      return handleSetRuleState(state, action);
    case DELETE_RULE_FROM_STATE:
      return handleDeleteRuleFromState(state, action);
    case UPDATE_ENABLED_DISABLED_STATE:
      return handleUpdateEnabledDisabledState(state, action);
    case PARSE_RULE_DONE:
      return handleParseRuleDoneState(state, action);
    default:
      return state;
  }
};

const handleSetRulesForApplicationConnectionRequest = (
  state: ReceiptRulesState,
  action: SetRulesForApplicationConnectionAction
) => {
  return {
    ...state,
    rules: action.payload?.rules,
    rulesConnectionId: action.payload.applicationConnectionId,
  };
};

const handleSetRuleState = (
  state: ReceiptRulesState,
  action: SetRuleStateAction
) => {
  const { ruleId, rule: newRule } = action.payload;
  const currentRules = state.rules || [];

  const ruleExists = currentRules.some((rule) => rule.id === ruleId);

  return {
    ...state,
    rules: ruleExists
      ? currentRules.map((rule) =>
          rule.id === ruleId ? { ...rule, ...newRule } : rule
        )
      : [...currentRules, { ...newRule }],
  };
};

const handleDeleteRuleFromState = (
  state: ReceiptRulesState,
  action: DeleteRuleFromStateAction
) => {
  const { ruleId } = action.payload;

  return {
    ...state,
    rules: state.rules ? state.rules.filter((rule) => rule.id !== ruleId) : [],
  };
};

const handleUpdateEnabledDisabledState = (
  state: ReceiptRulesState,
  action: UpdatedEnabledStateAction
) => {
  const { ruleId, enabled } = action.payload;

  return {
    ...state,
    rules: state.rules
      ? state.rules.map((rule) =>
          rule.id === ruleId ? { ...rule, enabled: enabled } : rule
        )
      : [],
  };
};

const handleParseRuleDoneState = (
  state: ReceiptRulesState,
  action: ParseRuleDoneAction
) => {
  return {
    ...state,
    parsedRule: action.payload.rule
  };
};
